import React, { forwardRef } from 'react';

import { Link } from '@change-corgi/core/react/router';

type DSLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
	href: string;
};

export const DSLink = forwardRef(({ href, ...rest }: DSLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
	<Link to={href} ref={ref} {...rest} />
));

DSLink.displayName = 'DSLink';
